import { render, staticRenderFns } from "./resales-list.pug?vue&type=template&id=4cdd3d42&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./resales-list.scss?vue&type=style&index=0&id=4cdd3d42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdd3d42",
  null
  
)

export default component.exports